import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { generatePeriodHeadings } from "../../utils/helperFunctions";
import { fetchFun } from "../../utils/fetchFun";

const initialState = {
  checkToken: {
    data: [],
    isLoading: false,
    error: null,
  },
  periodHeadingState: "",
  latestImportedData: null,
  formData: "",
  markupTableData: {},
  tbLibEntries: [],
  accountAndDetailTypes: []
}

// export const fetchTokenDetail = createAsyncThunk(
//   'user/fetchTokenDetail',
//   async (clientId) => {
//     try{
  
//       const raw = JSON.stringify({
//         "clientId": clientId
//       });
  
//       const response = await fetchFun(`/api/refreshTokenExpiry`, "POST", raw);
//       console.log("refreshTokenExpiry", {response, clientId})
//       return response;
//     } catch (error) {
//       console.log("Error refreshTokenExpiry", error)
//     }
//   }
// )

export const fetchLatestImportData = createAsyncThunk(
  'user/fetchLatestImportData',
  async (clientId) => {
    try {
      const response = await fetchFun(`/latestImportData/${clientId}`, "GET");
      if(!response.success){
				throw new Error("Import data not found!")
			}
      // const response = await responseRaw.json();
      return response;
    } catch (error) {
      console.log("Error - /latestImportData", error)
    }
  }
)

export const fetchCfsData = createAsyncThunk(
  'user/fetchCfsData',
  async (user) => {
    try {
      const response = await fetchFun(`/api/cashflow`, "GET")
      return response;
    } catch (err) {
      throw new Error(err)
    }
  }
)

export const fetchFormDetail = createAsyncThunk(
  'user/fetchFormDetail',
  async (user) => {
    try {
      const response = await fetchFun(`/api/company/${user._id}`, "GET");
      return response;
    } catch (err) {
      throw new Error(err)
    }
  }
)

export const fetchDropDownMarkupData = createAsyncThunk(
  'user/fetchDropDownMarkupData',
  async () => {
    try {
      const response = await fetchFun(`/api/dropdown/markup`, "GET");
      return response;
    } catch(err) {
      throw new Error(err)
    }
  }
)

export const fetchSavePeriodData = createAsyncThunk(
  'user/fetchSavePeriodData',
  async ({user, selectedClient, groupedData, periodType}) => {
    try {

      const raw = JSON.stringify({
        "user_id": user._id,
        "customerId": selectedClient?.customer,
        "clientId": selectedClient?._id,
        "period": periodType,
        "periodgroupedData": groupedData
      });

      const response = await fetchFun(`/api/periodGroupedData`, "POST", raw);
      return response;

    } catch(err) {
      throw new Error(err)
    }
  }
)

export const fetchAllTrialBalanceEntries = createAsyncThunk(
  'user/fetchAllTrialBalanceEntries',
  async ({user}) => {
    try {
      const response = await fetchFun(`/api/v1/tbLib`, "GET");
      return response?.data;
    } catch (error) {
      throw new Error(error)
    }
  }
)

export const fetchAccountAndDetailTypes = createAsyncThunk(
  'user/fetchAccountAndDetailTypes',
  async () => {
    try {
      const response = await fetchFun(`/api/account-types`, "GET");
      return response?.data;
    } catch (error) {
      throw new Error(error)
    }
  }
)

export const userSlice = createSlice({
    name: 'userSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      // builder.addCase(fetchTokenDetail.pending, (state) => {
      //   state.isLoading = true
      // })
      // builder.addCase(fetchTokenDetail.fulfilled, (state, action) => {
      //   state.isLoading = false
      //   state.data = action.payload
      // })
      // builder.addCase(fetchTokenDetail.rejected, (state, action) => {
      //   state.isLoading = false
      //   state.error = action.error.message
      // })
      builder.addCase(fetchLatestImportData.pending, (state) => {
        state.isLoading = true
      })
      builder.addCase(fetchLatestImportData.fulfilled, (state, action) => {
        state.isLoading = false
        state.data = action.payload
        state.latestImportedData = action.payload?.data
      })
      builder.addCase(fetchLatestImportData.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      builder.addCase(fetchFormDetail.pending, (state) => {
        state.isLoading = true
      })
      builder.addCase(fetchFormDetail.fulfilled, (state, action) => {
        state.isLoading = false
        state.periodHeadingState = generatePeriodHeadings(action?.payload?.data)
        state.data = action.payload
        state.formData = action.payload?.data
      })
      builder.addCase(fetchFormDetail.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      builder.addCase(fetchDropDownMarkupData.pending, (state) => {
        state.isLoading = true
      })
      builder.addCase(fetchDropDownMarkupData.fulfilled, (state, action) => {
        state.isLoading = false
        state.data = action.payload
        state.markupTableData = action.payload?.data?.data
      })
      builder.addCase(fetchDropDownMarkupData.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      builder.addCase(fetchSavePeriodData.pending, (state) => {
        state.isLoading = true
      })
      builder.addCase(fetchSavePeriodData.fulfilled, (state, action) => {
        state.isLoading = false
        state.data = action.payload
      })
      builder.addCase(fetchSavePeriodData.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      builder.addCase(fetchAllTrialBalanceEntries.pending, (state) => {
        state.isLoading = true
      })
      builder.addCase(fetchAllTrialBalanceEntries.fulfilled, (state, action) => {
        state.isLoading = false
        state.tbLibEntries = action.payload
      })
      builder.addCase(fetchAllTrialBalanceEntries.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      builder.addCase(fetchAccountAndDetailTypes.pending, (state) => {
        state.isLoading = true
      })
      builder.addCase(fetchAccountAndDetailTypes.fulfilled, (state, action) => {
        state.isLoading = false
        state.accountAndDetailTypes = action.payload
      })
      builder.addCase(fetchAccountAndDetailTypes.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
    },
  })

  export const {latestImportedData} = userSlice.actions;
  
  export default userSlice;